<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @print='print' @save="save" @del="del" @execute="execute"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[6796]')" name="0">
                        <wTable
                                id="xpane-0"
                                :data="dataSet"
                                :loading="loading"
                                :filter_language="['order_statusname','finance_status','negative_flag']"
                                :filter_date="['create_date','modify_date','audit_date']"
                                queryData="ISSReceiveToInvMasterViewInfo"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange"
                                :height="tableHeight-reduceTableHeight"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[3709]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="ipo_code" :label="$t('getapi[4283]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2203]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="verify_type" :label="$t('getapi[6774]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_category" :label="$t('getapi[6797]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4473]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[3672]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_date" :label="$t('getapi[734]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[3692]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6798]')" name="1">
                        <wTable
                                id="xpane-1"
                                :data="dataSet1"
                                :loading="loading"
                                queryData="ISSReceiveToInvMasterViewInfo"
                                :filter_language="['order_statusname','finance_status','negative_flag']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable1"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet1"
                                ref="singleTable1"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange1"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[3709]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="ipo_code" :label="$t('getapi[4283]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2203]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="verify_type" :label="$t('getapi[6774]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_category" :label="$t('getapi[6797]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4473]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[3672]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_date" :label="$t('getapi[734]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[3692]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6799]')" name="2">
                        <wTable
                                id="xpane-2"
                                :data="dataSet2"
                                :loading="loading"
                                queryData="ISSReceiveToInvMasterViewInfo"
                                :filter_language="['order_statusname','finance_status','negative_flag']"
                                :header="tableHeader"
                                :option="tableOption"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable2"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet2"
                                ref="singleTable2"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @selection-change="handleSelectionChange2"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[3709]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="ipo_code" :label="$t('getapi[4283]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname" :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2203]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="verify_type" :label="$t('getapi[6774]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_category" :label="$t('getapi[6797]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[2096]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4473]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[3672]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_date" :label="$t('getapi[734]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[3692]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" @click="excuteAccount" :disabled="!btn.excuteAccount">{{$t('getapi[2106]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="getNegativeBillInfo" :disabled="!btn.getNegativeBillInfo">{{
                            $t('getapi[4572]') }}
                        </el-button>
                    </div>
                    <div style="width:840px;min-width:840px">
                        <table>
                            <tr>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[3709]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.order_no" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4583]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-date-picker v-model="dataDetail.Head.create_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[1890]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.create_person" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[1862]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" :value="expFinanceStatus(dataDetail.Head.finance_status)" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1596]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.ipo_code" :readonly="true" class="readO" v-show="dataDetail.Head.order_status != 0"></el-input>
                                    <routejump :urlNo="40" v-show="dataDetail.Head.order_status == 0">
                                    <el-input
                                            v-model="dataDetail.Head.ipo_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"

                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectipocode"></i>
                                    </el-input>
                                    </routejump>
                                </td>
                                <td>{{ $t('getapi[732]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.audit_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[552]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" :value="expStatus(dataDetail.Head.order_status)" :readonly="true" class="readO"></el-input>
                                </td>
                                <td colspan="2">
                                    {{ $t('getapi[3705]') }}<el-checkbox  v-model="dataDetail.Head.negative_flag"  :true-label=1 :false-label=0 :disabled="true"></el-checkbox>
                                    {{ $t('getapi[3000]') }}<el-checkbox  v-model="dataDetail.Head.hook_flag"  :true-label=1 :false-label=0 :disabled="true"></el-checkbox>
                                    {{$t('getapi[6800]')}}<el-checkbox  v-model="dataDetail.Head.invoice_flag"  :true-label=1 :false-label=0 :disabled="true"></el-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[2876]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.base_order_no" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[6801]') }}</td>
                                <td>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.split_date" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[1864]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.keep_person" v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                    <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                    <el-input  type="text" v-model="dataDetail.Head.keep_person"
                                               readonly
                                               size="mini"

                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(1)"></i>
                                    </el-input>
                                    </routejump>
                                </td>
                                <td colspan="2">
                                    <span v-show="dataDetail.Head.negative_flag == 1">{{$t('getapi[6774]')}}<el-checkbox  v-model="dataDetail.Head.verify_type"  :true-label=1 :false-label=0 :disabled="dataDetail.Head.order_status != 0 || dataDetail.Head.negative_flag == 1"></el-checkbox></span>
                                    {{$t('getapi[6802]')}}<el-checkbox  v-model="dataDetail.Head.routing_flag"  :true-label=1 :false-label=0 :disabled="dataDetail.Head.order_status == 1 || dataDetail.Lists.length != 0 || dataDetail.Head.negative_flag == 1"></el-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1866]') }}</td>
                                <td>
                                    <el-select filterable v-model="dataDetail.Head.order_category" size="mini" v-if="dataDetail.Head.negative_flag == 0" :disabled="dataDetail.Head.order_status == 1">
                                        <el-option :label="$t('getapi[1903]')" :value="'入库'"></el-option>
                                        <el-option :label="$t('getapi[2903]')" :value="'调账'"></el-option>
                                    </el-select>
                                    <el-select filterable v-model="dataDetail.Head.order_category" size="mini" v-if="dataDetail.Head.negative_flag != 0" :disabled="dataDetail.Head.order_status == 1">
                                        <el-option :label="$t('getapi[1903]')" :value="'退货'"></el-option>
                                        <el-option :label="$t('getapi[2903]')" :value="'调账'"></el-option>
                                    </el-select>
                                </td>
                                <td>{{$t('getapi[6803]')}}</td>
                                <td>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.split_person" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{$t('getapi[6804]')}}</td>
                                <td>
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.regist_person" v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                    <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                    <el-input  type="text" v-model="dataDetail.Head.regist_person"
                                               readonly
                                               size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(2)"></i>
                                    </el-input>
                                    </routejump>
                                </td>
                                <td>{{ $t('getapi[143]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.remark" :readonly="dataDetail.Head.order_status == 1" :class="{'readO':dataDetail.Head.order_status == 1}"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <el-tabs :tab-position="'top'" type="" style="margin-top: 5px" @tab-click="selectInfo1">
                        <el-tab-pane :label="$t('getapi[6805]')" name="0">
                            <div class="btnnowrap">
                                <el-button type="primary" size="mini" @click="selectorderno('')" :disabled="dataDetail.Head.order_status != 0">{{$t('getapi[6092]')}}</el-button>
                                <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.batchDel">{{ $t('getapi[1522]') }}</el-button>
                                <el-button type="primary" size="mini" @click="createSerial" :disabled="!btn.createserial">
                                    {{$t('getapi[7121]')}}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-0"
                                    :data="dataDetail.Lists"
                                    @selection-change="handleSelectionChange"
                                    :row-class-name="tableRowClassName"
                                    :highlight-current-row="true"
                                    style="width: 100%; margin-top:3px"
                                    :height="tableHeight - 200"
                                    header-row-class-name="headerclass"
                                    size="mini"
                                    border
                                    ref="singleTable3"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"
                                                 align="right" width="50">
                                </el-table-column>
                                <el-table-column prop="regist_order_no" :label="$t('getapi[1874]')" width="120">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input
                                                v-model="scope.row.regist_order_no"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectorderno(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="regist_line_no" :label="$t('getapi[1875]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="ipo_line_no" :label="$t('getapi[4284]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="schedule_no" :label="$t('getapi[4209]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="page_no" :label="$t('getapi[133]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[2326]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="inv_unit" :label="$t('getapi[3100]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="enablereceiveqty" :label="$t('getapi[6806]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="enableselfbadqty" :label="$t('getapi[6807]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="enablescrapqty" :label="$t('getapi[6808]')" align="right"></el-table-column>
                                <el-table-column prop="receive_qty" :label="$t('getapi[1850]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.receive_qty"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="self_bad_qty" :label="$t('getapi[6758]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="scrap_qty" :label="$t('getapi[4220]')" align="right"></el-table-column>
                                <el-table-column prop="remark" :label="$t('getapi[143]')">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input size="mini" type="text" v-model="scope.row.remark"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="batch_no" :label="$t('getapi[1763]')">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input size="mini" type="text" v-model="scope.row.batch_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="sequence_no" :label="$t('getapi[1764]')">
                                    <template scope="scope" v-if="dataDetail.Head.order_status == 0">
                                        <el-input size="mini" type="text" v-model="scope.row.sequence_no" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="delivery_order_no" :label="$t('getapi[1744]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="createinvoiceqty" :label="$t('getapi[2003]')" align="right"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="releaseinvoiceqty" :label="$t('getapi[2004]')" align="right"></el-table-column>
                                
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[6026]')" name="1">
                            <div>
                                <el-button type="primary" size="mini" @click="batchDelS" :disabled="!btn.batchdels">{{
                                    $t('getapi[1522]') }}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-1"
                                    @selection-change="handleSelectionChangeDetailS"
                                    :row-class-name="tableRowClassNameDetailS"
                                    :data="dataDetail.SLists"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 220"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:3px"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="relation_line_no"
                                                 :label="$t('getapi[6040]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="so_code"
                                                 :label="$t('getapi[4285]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code"
                                                 :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version"
                                                 :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column prop="sequence_no" :label="$t('getapi[1764]')">
                                    <template scope="scope">
                                        <el-input v-model="scope.row.sequence_no" type="text" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="batch_no"
                                                 :label="$t('getapi[1763]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="qty"
                                                 :label="$t('getapi[1628]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="measureunit"
                                                 :label="$t('getapi[888]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="item_code"
                                                 :label="$t('getapi[6211]')"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ISSReceiveToInvMasterViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[1052]')" queryData="ISSReceiveToInvMasterViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--选择物料-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/ISS/Receive/GeIPOCodePopupDataList'" @callback="getipocode" ref="ipocode"></selector>
        <!--选择项目-->
        <selector :isVisible="false" :isBatch=true :isSplitPage=true :postUrl="'/ISS/Receive/GetRegistNoPopupDataList'" @callback="getorderno" ref="orderno"></selector>
        <!--选择项目-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/ISS/Receive/GetRegistNoPopupDataList'" @callback="getorderno" ref="ordernosingle"></selector>
        <!--保管员 记账员-->
        <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getperson" ref="person"></selector>
        <!--选择货位号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetActIssReceiveCargoPositionPopupList'" @callback="getcargo" ref="cargo"></selector>
        <!--选择入库单号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetActIssReceivePopupDataList'" @callback="getexeorderno" ref="exeorderno"></selector>
        <el-dialog v-dialogDrag :visible.sync="visProIssueExcute" width="80%" :close-on-click-modal="false" :show-close="false">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[3709]') }}</td>
                    <td style="width:150px;">
                        <el-input  type="text" v-model="dataDetailExecute.Head.order_no"
                                   readonly
                                   class="mcolor"
                                   size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectexeorderno"></i>
                        </el-input>
                    </td>
                    <td style="width:60px">{{ $t('getapi[4283]') }}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="mini" v-model="dataDetailExecute.Head.ipo_code" :readonly="true" class="readO"></el-input>
                    </td>
                    <td style="width:100px;"><el-checkbox  v-model="dataDetailExecute.Head.negative_flag"  :true-label=1 :false-label=0 :disabled="true"></el-checkbox>{{ $t('getapi[2096]') }}</td>
                    <td style="width:100px;"> <el-button type="primary" size="mini" @click="copyCargo()">{{ $t('getapi[11503]') }}</el-button></td>
                </tr>
            </table>
            <el-table
                    :data="dataDetailExecute.Lists"
                    :highlight-current-row="true"
                    :height="tableHeight - 255"
                    border
                    size="mini"
                    style="width: 100%; margin-top:5px"
            >
                <el-table-column type="selection" v-if="false"></el-table-column>
                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[4825]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receive_qty" :label="$t('getapi[1850]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="self_bad_qty" :label="$t('getapi[6758]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="scrap_qty" :label="$t('getapi[4220]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1842]')" width="180">
                    <template scope="scope">
                        <el-input  type="text" v-model="scope.row.cargo_position"
                                   readonly
                                   class="mcolor"
                                   size="mini"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcargo(scope)"></i>
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="workproc_id" :label="$t('getapi[2326]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="ipo_code" :label="$t('getapi[4283]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="ipo_line_no" :label="$t('getapi[4284]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="regist_order_no" :label="$t('getapi[1874]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="regist_line_no" :label="$t('getapi[1875]')" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visProIssueExcute = false" :disabled="!btn.closeExecute">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="executeSave" :disabled="!btn.executeSave" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isShowSerial" :title="$t('getapi[7122]')" width="30%"
                   :close-on-click-modal="false">
            <div>
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[6040]') }}</td>
                        <td style="width:100px;">
                            <el-input v-model="dataDetailSerial.relation_line_no" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[6052]')}}</td>
                        <td style="width:100px;">
                            <el-input v-model="dataDetailSerial.prefix" type="text" size="mini"
                                      :readonly="!btn.istracein" :class="{'readO':!btn.istracein}"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[112]') }}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.part_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[7124]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.digit" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                      size="mini" :readonly="!btn.istracein" :class="{'readO':!btn.istracein}"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[149]') }}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.part_version" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[7125]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.start" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                      size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[888]') }}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.measureunit" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[7126]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.count" type="text" size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[895]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.item_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{$t('getapi[7127]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.postfix" type="text" size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[7123]')}}</td>
                        <td>
                            <el-input :value="dataDetailSerial.trace_in == 0?$t('getapi[2053]'):$t('getapi[2052]')"
                                      type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowSerial = false" size="mini">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmCreate(0)" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'issuereceiveview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('issuereceiveview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('issuereceiveview1'), // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('issuereceiveview2'), // 当前页数据量
                total2: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                dataDetail:{
                    Head:{},
                    Lists: []
                },
                oldDataDetail: '',
                selectData: [],
                selectData1: [],
                selectData2: [],
                selectDataDetailS: [],
                btn:{
                    batchDel: false,
                    excuteAccount: false,
                    getNegativeBillInfo: false,
                    closeExecute: true,
                    executeSave: true,
                    createserial: false,
                    batchdels: false
                },
                rowindex: -1,
                dataDetailLineNo: 1,
                visProIssueExcute: false,
                dataDetailExecute: {
                    Head:{},
                    Lists:[]
                },
                rowindexcargo: -1,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                selectDataDetail: [],
                dataDetailSerial: {},
                isShowSerial: false,
                RightSelectIndex: '0',
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet1: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet2: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataDetail: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            }
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.$nextTick(() => {
                addEventListener('paste', that.keyPaste);//创建键盘粘贴监听事件
            });
            that.colsort();
            that.$processdata.pushModelCache('issuereceiveview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.srType = Array.methods.getSrType();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'issrelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        beforeDestroy() {
            let that = this
            removeEventListener('paste', that.keyPaste);
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ISSReceiveToInvMasterViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            tableRowClassName({ row, rowIndex }) {
                row.index = rowIndex;
            },
            tableRowClassNameDetailS({row, rowIndex}) {
                row.index = rowIndex;
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1052]"),this.$t("getapi[13]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if(!this.$limits.menuvisible("plv2", 141, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 140, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 141, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 141, 1) == 2) {
                        if (that.$limits.authority('plv3', 141,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 141,1) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                if(that.dataDetail.Head.order_status == 0){
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,export,refresh');
                            }
                        }
                        if (that.$limits.authority('plv3', 141, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                if(that.dataDetail.Head.order_status == 0){
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,export,refresh');
                            }
                        }
                    }
                }
                if(that.dataDetail.Head.order_status == 0 && that.dataDetail.Head.order_no != ''){
                    if(that.$limits.authority('plv2', 145, 1) > 0){
                        that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                    } else {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                    }
                }
                if(that.dataDetail.Head.order_status ==1){
                    that.$refs.SetBtn.SetOneBtnEnable('save', false)
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
                that.btn.excuteAccount = false
                that.btn.getNegativeBillInfo = false
                if(!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){
                    if(that.dataDetail.Head.order_status == 1){
                        if(that.dataDetail.Head.finance_status <= 0){
                            that.btn.excuteAccount = true
                        }
                        that.btn.getNegativeBillInfo = true
                    }
                }
                that.btn.batchDel = false
                that.btn.batchdels = false
                if(that.dataDetail.Head.order_status == 0){
                    if(that.selectData.length > 0){
                        if (that.$limits.authority('plv2', 141,1) == 2) {
                            if (that.$limits.authority('plv3', 141,1)> 0){
                                that.btn.batchDel = true
                            }
                        }
                    }
                    if (that.selectDataDetailS.length > 0) {
                        that.btn.batchdels = true
                    }
                }
                that.btn.createserial = false
                if (that.selectData.length == 1 && that.selectData[0].isSequenceTrace == true && that.selectData[0].workproc_name == '') {
                    that.btn.createserial = true
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('issuereceiveview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('issuereceiveview1',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.$http.savePageSize('issuereceiveview2',val)
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
            },
            selectInfo1(tab, event) {
                let that = this;
                that.RightSelectIndex = tab.name;
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ISSReceiveToInvMasterViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            print() {
            //判断状态
            let that = this;
            if(that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){ return; }
            that.$refs.SetBtn.SetOneBtnEnable('print', false);
            that.loading = true;
            let parm = {
            po_no: that.dataDetail.Head.order_no,
            TemplateName: '13委外入库单.xlsx'
            };
            that.$http.urlpost('/Print/WWRPrint', parm, function (res) {
            that.$refs.SetBtn.SetOneBtnEnable('print', true);
            if (res.Success == 1) {
            let hrefurl = res.Key;
            window.open(hrefurl);
            } 
            that.loading = false;
            });
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/ISS/Receive/IssReceiveViewList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.order_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 141, 1)){
                        return
                    }
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                    }
                    if(datacopy.SLists){
                        for(let i = 0;i<datacopy.SLists.length;i++){
                            delete datacopy.SLists[i]['index']
                        }
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.order_no
                                that.getDetail(row.order_no)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.SelectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.SelectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                }
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.order_no
                        that.getDetail(row.order_no)
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                if(datacopy.SLists){
                    for(let i = 0;i<datacopy.SLists.length;i++){
                        delete datacopy.SLists[i]['index']
                    }
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 0
                that.code = ''
                let date = Common.methods.getDate()
                that.dataDetail.Head = {
                    inner_no:"",
                    order_no:'',
                    ipo_code:'',
                    audit_date:"",
                    order_status:0,
                    remark:"",
                    create_person:'',
                    create_date:'',
                    modify_person:'',
                    modify_date:'',
                    hook_flag:0,
                    base_order_no:"",
                    verify_type:-1,
                    order_category:'入库',
                    finance_status:-1,
                    negative_flag:0,
                    split_person:"",
                    split_date:"",
                    keep_person:that.user,
                    regist_person:that.user,
                    finance_date:'',
                    routing_flag:1,
                    invoice_flag:0,
                    invoice_audit_date:null
                }
                that.dataDetail.Lists = []
                that.dataDetail.SLists = []
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
               /* let that = this;
                if(that.addoredit == 0){
                    that.add()
                } else {
                    that.getDetail(that.code)
                }
                that.getView();*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                if(datacopy.SLists){
                    for(let i = 0;i<datacopy.SLists.length;i++){
                        delete datacopy.SLists[i]['index']
                    }
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 0){
                                that.getView();
                                that.confirmAdd()
                            } else {
                                that.getView();
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/Receive/IssReceiveViewExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ISSReceiveToInvMasterViewInfo",
                    fromname: that.$t('getapi[1052]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail
                parm.LangType =  that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/ISS/Receive/IssReceiveSaveData', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/ISS/Receive/GetIssReceiveBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority()
                        that.$nextTick(function() {
                            that.$processdata.initFormRight(this.RightSelectIndex)
                        })
                    }
                    loadingInstance.close()
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange1(val){
                let that = this;
                that.selectData1 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData1.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange2(val){
                let that = this;
                that.selectData2 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData2.push(val[i]);
                }
                that.btnauthority()
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no : that.dataDetail.Head.order_no,
                            modify_date:that.dataDetail.Head.modify_date
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/ISS/Receive/DelIssReceiveBill', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //获取采购订单
            selectipocode() {
                let that = this;
                if(that.dataDetail.Lists.length > 0){
                    that.$message.warning(that.$t('getapi[8834]'))//入库单据存在明细行，不能更换外协订单！
                    return false
                }
                that.$refs.ipocode.clearInput(true);
            },
            // 获取订单信息
            getipocode(data) {
                let that = this;
                console.log(data)
                that.dataDetail.Head.ipo_code = data.relation_ipo_code
            },
            selectorderno(row) {
                let that = this;
                if(that.dataDetail.Head.ipo_code == '' || that.dataDetail.Head.ipo_code == null){
                    that.$message.warning(that.$t('getapi[2734]'));//'订单编号不能为空'
                    return
                }
                if (row == '') {
                    that.oneormore = 1;
                    let param = {
                        ipo_code: that.dataDetail.Head.ipo_code,
                        base_order_no: that.dataDetail.Head.base_order_no,
                        last_routing_flag: that.dataDetail.Head.routing_flag,
                        negative_flag: that.dataDetail.Head.negative_flag
                    }
                    that.$refs.orderno.clearInput(true, param);
                } else {
                    that.oneormore = 2;
                    this.rowindex = row.$index;
                    let param = {
                        ipo_code: that.dataDetail.Head.ipo_code,
                        base_order_no: that.dataDetail.Head.base_order_no,
                        last_routing_flag: that.dataDetail.Head.routing_flag,
                        negative_flag: that.dataDetail.Head.negative_flag
                    }
                    that.$refs.ordernosingle.clearInput(true, param);
                }
            },
            getorderno(data){
                let that = this;
                console.log(data);
                let parmarr = []
                if (that.oneormore == 1) {
                    for(let i=0;i<data.length;i++){
                        parmarr = [...parmarr,{
                            regist_order_no: data[i].relation_order_no,
                            regist_line_no: data[i].regist_line_no,
                            base_order_no: that.dataDetail.Head.base_order_no,
                            delivery_order_no: data[i].delivery_order_no,
                            ipo_line_no: data[i].ipo_line_no,
                            part_code: data[i].part_code,
                            part_name: data[i].part_name,
                            part_version: data[i].part_version,
                            negative_flag: that.dataDetail.Head.negative_flag,
                            routing_flag: that.dataDetail.Head.routing_flag,
                            workproc_name: data[i].workproc_name,
                            page_no:data[i].page_no,
                            schedule_no:data[i].schedule_no,
                        }]
                    }
                    let parm = {
                       Lists: parmarr,
                        LangType: that.$processdata.getLang(),
                    }
                    that.$http.urlpost('/ISS/Receive/GetLinesBySelRegistNo', parm, function (res) {
                        if (res.Success == 1) {
                            let dataD = res.DataContent.Lists
                            let arr = dataD.filter(item => {
                                return that.dataDetail.Lists.every(item2 => {
                                    return item.ipo_line_no != item2.ipo_line_no;
                                });
                            });
                            dataD = arr;
                            that.dataDetailLineNo = 1
                            for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                                if (that.dataDetail.Lists[i].line_no >= that.dataDetailLineNo) {
                                    that.dataDetailLineNo = that.dataDetail.Lists[i].line_no + 1
                                }
                            }
                            for(let i = 0;i<dataD.length;i++){
                                that.dataDetail.Lists = [...that.dataDetail.Lists,{
                                    exclusively_id: dataD[i].exclusively_id,
                                    relation_order_no: dataD[i].exclusively_id,
                                    line_no: that.dataDetailLineNo++,
                                    regist_order_no: dataD[i].regist_order_no,
                                    regist_line_no: dataD[i].regist_line_no,
                                    part_code: dataD[i].part_code,
                                    part_name: dataD[i].part_name,
                                    part_version: dataD[i].part_version,
                                    workproc_name: dataD[i].workproc_name,
                                    inv_unit: dataD[i].inv_unit,
                                    receive_qty: dataD[i].receive_qty,
                                    self_bad_qty: dataD[i].self_bad_qty,
                                    scrap_qty: dataD[i].scrap_qty,
                                    enablereceiveqty: dataD[i].enablereceiveqty,
                                    enableselfbadqty: dataD[i].enableselfbadqty,
                                    enablescrapqty: dataD[i].enablescrapqty,
                                    remark: dataD[i].remark,
                                    batch_no: dataD[i].batch_no,
                                    sequence_no: dataD[i].sequence_no,
                                    ipo_line_id: dataD[i].ipo_line_id,
                                    so_code: dataD[i].so_code,
                                    unit_price: dataD[i].unit_price,
                                    line_net_total_amount: dataD[i].line_net_total_amount,
                                    rec_material_unit: dataD[i].rec_material_unit,
                                    rec_man_unit: dataD[i].rec_man_unit,
                                    rec_charge_unit: dataD[i].rec_charge_unit,
                                    rec_charge_material_unit: dataD[i].rec_charge_material_unit,
                                    rec_carry_man_unit: dataD[i].rec_carry_man_unit,
                                    rec_carry_charge_unit: dataD[i].rec_carry_charge_unit,
                                    rec_material_amount: dataD[i].rec_material_amount,
                                    rec_man_amount: dataD[i].rec_man_amount,
                                    rec_charge_amount: dataD[i].rec_charge_amount,
                                    rec_charge_material_amount: dataD[i].rec_charge_material_amount,
                                    rec_carry_man_amount: dataD[i].rec_carry_man_amount,
                                    rec_carry_charge_amount: dataD[i].rec_carry_charge_amount,
                                    routing_relation_no: dataD[i].routing_relation_no,
                                    releaseinvoiceqty: dataD[i].releaseinvoiceqty,
                                    createinvoiceqty: dataD[i].createinvoiceqty,
                                    base_order_no: dataD[i].base_order_no,
                                    delivery_order_no: dataD[i].delivery_order_no,
                                    ipo_line_no: dataD[i].ipo_line_no,
                                    page_no: dataD[i].page_no,
                                    schedule_no: dataD[i].schedule_no,                                    
                                    
                                }]
                            }
                        }
                    });
                } else {
                    parmarr = [...parmarr,{
                        regist_order_no: data.relation_order_no,
                        regist_line_no: data.regist_line_no,
                        base_order_no: that.dataDetail.Head.base_order_no,
                        delivery_order_no: data.delivery_order_no,
                        ipo_line_no: data.ipo_line_no,
                        part_code: data.part_code,
                        part_name: data.part_name,
                        part_version: data.part_version,
                        negative_flag: that.dataDetail.Head.negative_flag,
                        routing_flag: that.dataDetail.Head.routing_flag,
                        workproc_name: that.dataDetail.Head.workproc_name,
                        page_no:data.page_no,
                        schedule_no:data.schedule_no,                        
                    }]
                    let parm = {
                        Lists: parmarr,
                        LangType: that.$processdata.getLang(),
                    }
                    that.$http.urlpost('/ISS/Receive/GetLinesBySelRegistNo', parm, function (res) {
                        if (res.Success == 1) {
                            let dataD = res.DataContent.Lists
                            //that.dataDetail.Lists[that.rowindex] = dataD
                            that.dataDetail.Lists[that.rowindex].exclusively_id = dataD[0].exclusively_id,
                            that.dataDetail.Lists[that.rowindex].relation_order_no= dataD[0].relation_order_no,
                            that.dataDetail.Lists[that.rowindex].regist_order_no= dataD[0].regist_order_no,
                            that.dataDetail.Lists[that.rowindex].regist_line_no= dataD[0].regist_line_no,
                            that.dataDetail.Lists[that.rowindex].part_code= dataD[0].part_code,
                            that.dataDetail.Lists[that.rowindex].part_name= dataD[0].part_name,
                            that.dataDetail.Lists[that.rowindex].part_version= dataD[0].part_version,
                            that.dataDetail.Lists[that.rowindex].workproc_name= dataD[0].workproc_name,
                            that.dataDetail.Lists[that.rowindex].inv_unit= dataD[0].inv_unit,
                            that.dataDetail.Lists[that.rowindex].receive_qty= dataD[0].receive_qty,
                            that.dataDetail.Lists[that.rowindex].self_bad_qty= dataD[0].self_bad_qty,
                            that.dataDetail.Lists[that.rowindex].scrap_qty= dataD[0].scrap_qty,
                            that.dataDetail.Lists[that.rowindex].enablereceiveqty= dataD[0].enablereceiveqty,
                            that.dataDetail.Lists[that.rowindex].enableselfbadqty= dataD[0].enableselfbadqty,
                            that.dataDetail.Lists[that.rowindex].enablescrapqty= dataD[0].enablescrapqty,
                            that.dataDetail.Lists[that.rowindex].remark= dataD[0].remark,
                            that.dataDetail.Lists[that.rowindex].batch_no= dataD[0].batch_no,
                            that.dataDetail.Lists[that.rowindex].sequence_no= dataD[0].sequence_no,
                            that.dataDetail.Lists[that.rowindex].ipo_line_id= dataD[0].ipo_line_id,
                            that.dataDetail.Lists[that.rowindex].so_code= dataD[0].so_code,
                            that.dataDetail.Lists[that.rowindex].unit_price= dataD[0].unit_price,
                            that.dataDetail.Lists[that.rowindex].line_net_total_amount= dataD[0].line_net_total_amount,
                            that.dataDetail.Lists[that.rowindex].rec_material_unit= dataD[0].rec_material_unit,
                            that.dataDetail.Lists[that.rowindex].rec_man_unit= dataD[0].rec_man_unit,
                            that.dataDetail.Lists[that.rowindex].rec_charge_unit= dataD[0].rec_charge_unit,
                            that.dataDetail.Lists[that.rowindex].rec_charge_material_unit= dataD[0].rec_charge_material_unit,
                            that.dataDetail.Lists[that.rowindex].rec_carry_man_unit= dataD[0].rec_carry_man_unit,
                            that.dataDetail.Lists[that.rowindex].rec_carry_charge_unit= dataD[0].rec_carry_charge_unit,
                            that.dataDetail.Lists[that.rowindex].rec_material_amount= dataD[0].rec_material_amount,
                            that.dataDetail.Lists[that.rowindex].rec_man_amount= dataD[0].rec_man_amount,
                            that.dataDetail.Lists[that.rowindex].rec_charge_amount= dataD[0].rec_charge_amount,
                            that.dataDetail.Lists[that.rowindex].rec_charge_material_amount= dataD[0].rec_charge_material_amount,
                            that.dataDetail.Lists[that.rowindex].rec_carry_man_amount= dataD[0].rec_carry_man_amount,
                            that.dataDetail.Lists[that.rowindex].rec_carry_charge_amount= dataD[0].rec_carry_charge_amount,
                            that.dataDetail.Lists[that.rowindex].routing_relation_no= dataD[0].routing_relation_no,
                            that.dataDetail.Lists[that.rowindex].releaseinvoiceqty= dataD[0].releaseinvoiceqty,
                            that.dataDetail.Lists[that.rowindex].createinvoiceqty= dataD[0].createinvoiceqty,
                            that.dataDetail.Lists[that.rowindex].base_order_no= dataD[0].base_order_no,
                            that.dataDetail.Lists[that.rowindex].delivery_order_no= dataD[0].delivery_order_no,
                            that.dataDetail.Lists[that.rowindex].ipo_line_no= dataD[0].ipo_line_no,
                            that.dataDetail.Lists[that.rowindex].page_no= dataD[0].page_no,
                            that.dataDetail.Lists[that.rowindex].schedule_no= dataD[0].schedule_no  
                                                     
                        }
                    });
                }
            },
            batchDel(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            modify_date: that.dataDetail.Head.modify_date,
                            iscontinue: 0,
                            Lists: []
                        };
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.Lists.splice(that.selectData[i].index, 1);
                            if(that.selectData[i].exclusively_id!="" && that.selectData[i].exclusively_id!=0){
                                let datatmp = {
                                    exclusively_id:that.selectData[i].exclusively_id,
                                    line_No: that.selectData[i].line_no
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        if(parm.Lists.length>0){
                            that.$http.urlpost('/ISS/Receive/DelIssReceiveRows', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                } else if(res.Success == 2){
                                    that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                        confirmButtonText: that.$t('getapi[1146]'),
                                        cancelButtonText: that.$t('getapi[2054]'),
                                        type: 'warning'
                                    })
                                        .then(() => {
                                            parm.iscontinue = 1
                                            that.$http.urlpost('/ISS/Receive/DelIssReceiveRows', parm, function (res1) {
                                                if (res1.Success == 1) {
                                                    that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                                    if (that.code != '') {
                                                        that.getDetail(that.code);
                                                    }
                                                }else{
                                                    if (that.code != '') {
                                                        that.getDetail(that.code);
                                                    }
                                                }
                                            })
                                        })
                                        .catch(() => {
                                            this.$message({
                                                type: 'info',
                                                message: that.$t('getapi[6096]')
                                            });
                                        });
                                }
                                else{
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            handleSelectionChangeDetailS(val) {
                // 明细选择
                let that = this;
                that.selectDataDetailS = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataDetailS.push(val[i]);
                }
                console.log(that.selectDataDetailS.length)
                that.btnauthority();
            },
            batchDelS() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = []
                        for (let i = that.selectDataDetailS.length - 1; i >= 0; i--) {
                            that.dataDetail.SLists.splice(that.selectDataDetailS[i].index, 1);
                            if (that.selectDataDetailS[i].isadd == 0) {
                                parm.push(that.selectDataDetailS[i]);
                            }
                        }
                        if (parm.length > 0) {
                            that.$http.urlpost('/ISS/Receive/ReceieveLineSerialListDelete', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 执行记账
            excuteAccount(){
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    modify_date: that.dataDetail.Head.modify_date
                }
                that.$http.urlpost('/ISS/Receive/ExecuteAccount', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code);
                    }
                })
            },
            expFinanceStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[941]')//'审核';
                } else if (val == 1) {
                    return that.$t('getapi[1868]')//'记账';
                } else if (val == 2) {
                    return that.$t('getapi[1273]')//'月结';
                } else {
                    return '';
                }
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[941]')//'审核';
                } else if (val == 2) {
                    return that.$t('getapi[1902]')//'作废';
                } else {
                    return '';
                }
            },
            selectperson(val){
                let that = this;
                that.personType = val
                that.$refs.person.clearInput(true);
            },
            getperson(data){
                let that = this
                console.log(data)
                if(that.personType == 1){
                    that.dataDetail.Head.keep_person = data.name
                } else if(that.personType == 2){
                    that.dataDetail.Head.regist_person = data.name
                }
            },
            // 生成红字单
            getNegativeBillInfo(){
                let that = this
                let parm = that.dataDetail
                that.$http.urlpost('/ISS/Receive/IssReceiveExeNegativeBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.dataDetail = res.DataContent
                    }
                    that.authority();
                })
            },
            // 执行
            execute(){
                let that = this
                that.visProIssueExcute = true
                that.getIssReceiveBillInfo(that.dataDetail.Head.order_no)
            },
            // 执行信息获取
            getIssReceiveBillInfo(code){
                let that = this
                let parm = {
                    Code: code,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Inv/Action/GetActIssReceiveBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailExecute = res.DataContent;
                        that.btn.executeSave = true
                    }
                })
            },
            // 选择货位
            selectcargo(row){
                let that = this;
                console.log("测试1；")
                 that.rowindexcargo = row.$index
                let param = {
                    order_no: that.dataDetailExecute.Lists[that.rowindexcargo].order_no,
                    receive_qty: that.dataDetailExecute.Lists[that.rowindexcargo].receive_qty,
                    ipo_line_id: that.dataDetailExecute.Lists[that.rowindexcargo].ipo_line_id,
                    negative_flag: that.dataDetailExecute.Head.negative_flag,
                    line_no: that.dataDetailExecute.Lists[that.rowindexcargo].line_no,
                    part_code: that.dataDetailExecute.Lists[that.rowindexcargo].part_code,
                    part_version: that.dataDetailExecute.Lists[that.rowindexcargo].part_version,
                    sequence_no: that.dataDetailExecute.Lists[that.rowindexcargo].sequence_no
                }
                if(that.dataDetailExecute.Lists[that.rowindexcargo].receive_qty==0 ){
                    return ;
                }
                //分页情况
				let data = {
					PageIndex: that.pageIndex,
					PageSize: that.pageSize,
					//默认子参数
					Param: param
                };   
                //先校验在弹窗            
                that.$http.urlpost("/Inv/Action/GetActIssReceiveCargoPositionPopupList", data, function(res) {
                    //检验外协是最后工序 才弹窗货位选择
                    if(res.Success==1){
                        that.$refs.cargo.clearInput(true, param);
                    }
                    //res.Success==2
                    //检验外协是否最后工序
                })
            },
            getcargo(data){
                let that = this
                that.dataDetailExecute.Lists[that.rowindexcargo].cargo_position = data.cargoposition_code
                let parm = {
                    part_code: that.dataDetailExecute.Lists[that.rowindexcargo].part_code,
                    part_version: that.dataDetailExecute.Lists[that.rowindexcargo].part_version,
                }
                that.$http.urlpost('/Inv/Action/CheckDefaultCargoPosition', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    } else if (res.Success == 2) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                let parm1 = {
                                    part_code: that.dataDetailExecute.Lists[that.rowindexcargo].part_code,
                                    part_version: that.dataDetailExecute.Lists[that.rowindexcargo].part_version,
                                    cargo_position: that.dataDetailExecute.Lists[that.rowindexcargo].cargo_position,
                                    isdefault: 1
                                }
                                that.$http.urlpost('/Inv/MaterialIn/GetSetDefaultPosition', parm1, function (res1) {
                                    if (res1.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                    }
                                })
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            copyCargo(){
                let that = this
                if(that.dataDetailExecute.Lists.length>0){
                    if(that.$limits.fnIsEmpty(that.dataDetailExecute.Lists[0].cargo_position)){
                        return
                    } else {
                        for(let i = 0;i<that.dataDetailExecute.Lists.length;i++){
                            if(that.$limits.fnIsEmpty(that.dataDetailExecute.Lists[i].cargo_position)){
                                that.dataDetailExecute.Lists[i].cargo_position = that.dataDetailExecute.Lists[0].cargo_position
                            }
                        }
                    }
                } else {
                    that.$message.warning(that.$t('getapi[9036]'))
                }
            },
            selectexeorderno(){
                let that = this;
                that.$refs.exeorderno.clearInput(true);
            },
            getexeorderno(data){
                let that = this
                console.log(data)
                that.btn.executeSave = true
                that.dataDetailExecute.Head.order_no = data.order_no
                that.dataDetailExecute.Head.ipo_code = data.ipo_code
                that.dataDetailExecute.Head.negative_flag = data.negative_flag
                that.getIssReceiveBillInfo(that.dataDetailExecute.Head.order_no)
            },
            // 执行保存
            executeSave(){
                let that = this
                let parm = that.dataDetailExecute
                parm.LangType = that.$processdata.getLang()
                that.btn.executeSave = false
                that.btn.closeExecute = false
                that.$http.urlpost('/Inv/Action/ActIssReceiveSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    } else {
                        that.btn.executeSave = true
                    }
                    that.btn.closeExecute = true
                })
            },
            //生成序列号
            createSerial() {
                let that = this
                that.btn.istracein = true
                that.isShowSerial = true
                that.dataDetailSerial = {
                    relation_line_no: that.selectData[0].line_no,
                    part_code: that.selectData[0].part_code,
                    part_version: that.selectData[0].part_version,
                    measureunit: that.selectData[0].inv_unit,
                    prefix: '',
                    digit: '',
                    start: 1,
                    count: that.selectData[0].receive_qty,
                    postfix: '',
                    item_code: that.selectData[0].ITEM_CODE,
                    trace_in: ''
                }
            },
            confirmCreate(val) {
                let that = this
                let parm = {
                    relation_order_no: that.selectData[0].relation_order_no,
                    so_code: that.selectData[0].so_code,
                    issequencetrace: 1,
                    trace_in: '',
                    iscontinue: val,
                    Head: that.dataDetailSerial,
                    SerialList: that.dataDetail.SLists == null ? []:that.dataDetail.SLists,
                    List: that.selectData
                }
                that.$http.urlpost('/ISS/Receive/IssReceieveCreateSerial', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowSerial = false
                        that.dataDetail.SLists = res.DataContent.SerialList
                    } else if (res.Success > 1) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.confirmCreate(res.Success);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            // 粘贴
            keyPaste(e) {
                let that = this;
                if ((this.$route.name == this.$options.name) && (that.RightSelectIndex == 1)) {
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.check(data);
                        }
                    }
                }
            },
            check(datap) {
                let that = this
                console.log(JSON.stringify(datap))
                let str = JSON.stringify(datap)
                str = str.replace('"', '').replace('"', '')
                let arr = str.split("\\r\\n")
                console.log('arr' + arr)
                let arrlist = []
                for (let i = 0; i < arr.length - 1; i++) {
                    if (arr[i].split('\\t').length == 3) {
                        arrlist = [...arrlist, {
                            part_code: arr[i].split('\\t')[0],
                            part_version: arr[i].split('\\t')[1],
                            sequence_no: arr[i].split('\\t')[2],
                        }]
                    }
                }
                if (arrlist.length > 0) {
                    for(let i = 0;i<that.dataDetail.SLists.length;i++){
                        for(let j=0;j<arrlist.length;j++) {
                            if ((that.dataDetail.SLists[i].part_code + that.dataDetail.SLists[i].part_version) == (arrlist[j].part_code + arrlist[j].part_version)) {
                                that.dataDetail.SLists[i].sequence_no = arrlist[j].sequence_no
                                arrlist.splice(j,1)
                                break
                            }
                        }
                    }
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 141,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                if(datacopy.SLists){
                    for(let i = 0;i<datacopy.SLists.length;i++){
                        delete datacopy.SLists[i]['index']
                    }
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
